import React from 'react';
import styled from 'styled-components';


const CampusInsightsCard = () => {
  return (
    //  <PageBackground>
    <CardContainer>
      <InnerContainer>
      <MainContent>
       <HeaderContainer>
      <TitleContainer>
        <MainTitle>
          Discover the ROI of Campus Insights
        </MainTitle>
        <Subtitle>
          Redefining Student Support and Intelligence
        </Subtitle>
      </TitleContainer>
    </HeaderContainer>
      
      
      <ContentContainer>
      <IntroductionParagraph>
        In today's competitive higher education landscape, attracting and
        retaining students while managing staff workload is a constant
        challenge. Discover how Campus Insights, a transformative generative
        AI engagement layer, is redefining student support and institutional
        intelligence.
      </IntroductionParagraph>
      <DetailsParagraph>
        This white paper reveals the measurable Return on Investment (ROI)
        for colleges and universities implementing Campus Insights, from
        boosting operational efficiency and enrollment to enhancing
        data-driven decision-making and student retention.
      </DetailsParagraph>
    </ContentContainer>

        <LearningPoints />
      </MainContent>
     <CtaSection>
      <CtaText>
        Transform your student support and gain invaluable insights. Kindly
        fill out the form to gain access to the complete Campus Insights
        whitepaper.
      </CtaText>
    
        <IframeContainer>
            <Iframe
              src="https://easy-donate.kit.com/39c9acce83"
              frameBorder="0"
              allowFullScreen
            />
          </IframeContainer>
        
    </CtaSection>
    </InnerContainer>
    </CardContainer>
      // </PageBackground>
  );
};


const IframeContainer = styled.div`
  width: 100%;
  height: 700px;  
  display: flex;
  justify-content: center;  
  
  @media (max-width: 991px) {     
  height: 600px; 
  }
  @media (max-width: 601px) {     
  height: 550px; 
  }
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%; /* Full viewport height on mobile */
  border: none;
  border-radius: 8px;

  @media (max-width: 480px) {
    height: 200vh; /* Allow bit extra space on very small phones */
  }
`;

const CtaSection = styled.section`
  margin: 64px 0 0 0;
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
  }
`;

const CtaText = styled.p`
  width: 100%;
  font-size: 18px;
  color: #64636a;
  font-weight: 600;
  letter-spacing: -0.18px;
  line-height: 25px;
  margin: 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;


const LearningPoints = () => {
  const learningItems = [
    "How Campus Insights reduces repetitive questions by 30-60%, saving hundreds of staff hours.",
    "Strategies to increase application-to-enrollment conversion by 5-10% through proactive support.",
    "The power of real-time analytics to identify student needs and improve campus policies.",
    "How to achieve a 1-3% increase in student retention through 24/7 personalized support.",
    "A clear breakdown of cost vs. value, demonstrating how Campus Insights often pays for itself within the first academic cycle."
  ];

  return (
    <LearningSection>
      <SectionTitle>What you'll learn:</SectionTitle>
      <LearningList>
        {learningItems.map((item, index) => (
          <LearningItem key={index}>
            {item}
          </LearningItem>
        ))}
      </LearningList>
    </LearningSection>
  );
};

const LearningSection = styled.section`
  margin: 42px 0 0 0;
  width: 100%;
  font-size: 16px;
  color: #64636a;
  font-weight: 500;
  letter-spacing: -0.08px;
  line-height: 1.6;
  @media (max-width: 991px) {
    max-width: 100%;
    margin-top: 40px;
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: -0.18px;
  margin: 0 0 20px 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const LearningList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const LearningItem = styled.li`
  margin: 20px 0 0 0;
  position: relative;
  padding-left: 20px;

  &:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #64636a;
  }

  &:first-child {
    margin-top: 0;
  }

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;


const ContentContainer = styled.section`
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const IntroductionParagraph = styled.p`
  color: #64636a;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.08px;
  line-height: 26px;
  margin: 32px 0 0 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const DetailsParagraph = styled.p`
  color: #64636a;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.08px;
  line-height: 26px;
  margin: 32px 0 0 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;


const HeaderContainer = styled.header`
  width: 100%;
  line-height: 26px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const TitleContainer = styled.div`
  // width: 956px;
  max-width: 100%;
  line-height: 1.2;
`;

const MainTitle = styled.h1`
  color: #1c1b1f;
  font-size: 48px;
  font-weight: 700;
  letter-spacing: -0.48px;
  margin: 0;
  @media (max-width: 991px) {
    max-width: 100%;
    font-size: 40px;
  }
`;

const Subtitle = styled.h2`
  color: rgba(100, 99, 106, 1);
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.32px;
  margin: 20px 0 0 0;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const CardContainer = styled.article`
  padding: 52px 0;
  background: #F5F5F9;
  width: 100%;  
  @media (max-width: 991px) {  
    padding: 0;  
    background: none;
  }
  `

const InnerContainer = styled.article`
  border-radius: 24px;
  background: #FFFFFF;
  font-family: Inter, -apple-system, Roboto, Helvetica, sans-serif;
  background-color: var(--Colors-White, #fff);
  margin: 0 210px;
  padding: 64px 48px 0px;
  border-radius: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  @media (max-width: 1291px) {  
  margin: 52px 110px;
  }
  @media (max-width: 991px) {  
    margin: 0;  
    padding: 40px 50px 0;
  }
`;

const MainContent = styled.div`
  width: 100%;
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export default CampusInsightsCard;
